/* Slider with tab navigation */
import 'slick-carousel';

export function slider_with_tab_navigation() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--slider-with-tab-navigation' ).length <= 0 ) {
				return;
			}

			$( '.block--slider-with-tab-navigation' ).each( ( i, e ) => {
				const wrapper = $( e );
				const slider = $( e ).find( '.tab-content' );

				slider.slick( {
					arrows: true,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: false,
					fade: true,
					rows: 0,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								// arrows: false,
								dots: true,
								draggable: true,
								fade: false,
								adaptiveHeight: true,
							}
						}
					]
				} );

				// Set tab to active when the slider moves on its own
				slider.on( 'afterChange', ( ev, currentSlide, nextSlide ) => {
					const currentButton = wrapper.find( '.btn.current' );
					$( currentButton ).removeClass( 'current' );

					wrapper.find( '.tab-list > div > button' ).each( ( i, e ) => {
						if ( nextSlide == $( e ).data( 'slide-order' ) ) {
							$( e ).addClass( 'current' );
						}
					} );
				} );

				// Click on tab
				wrapper.find( '.tab-list > div > button' ).each( ( i, e ) => {
					$( e ).on( 'click', ( ev ) => {
						const slideNumber = $( ev.currentTarget ).data( 'slide-order' );
						const currentButton = wrapper.find( '.btn.current' );
						$( currentButton ).removeClass( 'current' );
						$( ev.currentTarget ).addClass( 'current' );
						slider.slick( 'slickGoTo', slideNumber );
						ev.preventDefault();
					} );
				} );
				
			} );
		}

		init();
		// $( window ).on( 'resize', init );

	} )( window.jQuery );
}